module.exports = __webpack_public_path__ + "static/media/inertia.9b3ed5c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landscape/inertia.jpg
// module id = 301
// module chunks = 0